import React, { useEffect } from "react";
import "./app.css";
import SignUp from "./pages/signup";
import { HashRouter, Routes, Route } from "react-router-dom";
import Settings from "./pages/settings";
import Dashboard from "./pages/dashboard";
import AddUser from "./pages/addUser";
import { Private, AdminOnly, OnboardingOnly, AuthWrapper } from "./components/privateRouter";
import { Capacitor } from "@capacitor/core";
import { App as CapApp } from "@capacitor/app";
import DoupleButton from "./pages/calender";
import PublicTable from "./pages/public";
import Analytics from "./pages/analytics";
import About from "./pages/about";
import WaiterLogin from "./pages/waiterLogin";
import Onboarding from "./pages/onboarding";
import MenuSettings from "./pages/menuSettings";
import StaffSettings from "./pages/staffSettings";
import TableSettings from "./pages/tableSettings";
import Report from "./pages/report";
import PublicLink from "./pages/publicLink";
import Welcome from "./pages/welcome";
import Profile from "./pages/profile";

const App = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    const listenerPromise = CapApp.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        CapApp.exitApp();
      }
    });
    return () => { listenerPromise.then((l) => l.remove()); };
  }, []);

  return (
    <HashRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<AuthWrapper Component={SignUp} />} />
        <Route path="/waiter-login" element={<WaiterLogin />} />
        <Route path="public/waitlist/:id" element={<PublicTable />} />

        {/* Admin + Waiter routes */}
        <Route path="/dashboard" element={<Private Component={Dashboard} />} />
        <Route path="/addUser/:id" element={<Private Component={AddUser} />} />
        <Route path="/about" element={<Private Component={About} />} />

        {/* Admin-only routes */}
        <Route path="/settings" element={<AdminOnly Component={Settings} />} />
        <Route path="/calender" element={<AdminOnly Component={DoupleButton} />} />
        <Route path="/analytics" element={<AdminOnly Component={Analytics} />} />
        <Route path="/onboarding" element={<OnboardingOnly Component={Onboarding} />} />
        <Route path="/welcome" element={<OnboardingOnly Component={Welcome} />} />
        <Route path="/menu-settings" element={<AdminOnly Component={MenuSettings} />} />
        <Route path="/staff-settings" element={<AdminOnly Component={StaffSettings} />} />
        <Route path="/table-settings" element={<AdminOnly Component={TableSettings} />} />
        <Route path="/report" element={<AdminOnly Component={Report} />} />
        <Route path="/public-link" element={<AdminOnly Component={PublicLink} />} />
        <Route path="/profile" element={<AdminOnly Component={Profile} />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
